/**
 * Created by claudio iozzia on 22/06/2017.
 */
import {AcceptorOutputFn, andAcceptorSingle} from "../../../../models/acceptor/IAcceptor";
import {Ic} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {ISingleOutput} from "../../../../models/ISpec";
import {Utils} from "../../../../common/utils";
import {acceptSingle_common_Iout, acceptSingle_common_Vout} from "./dcdc__common_acceptor";
import {Acceptor_Common} from "../../../../models/acceptor/acceptor_common";
import {IC_fsw} from "../../../../models/IC_fsw";

export class Acceptor_DcDc_Buck extends Acceptor_Common {

  constructor (ledDcDc: boolean= false) {super(ledDcDc); }

  protected acceptSingle_Buck_Vout: AcceptorOutputFn = (ic: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    const dMax = new IC_fsw(ic).dMax;
    /* check if single voltage output is defined and inside the bounds */

    const ret = ((Utils.isValueEmpty(out.voltage)) || (Utils.isValueEmpty(spec.spec.value.input.min)) || (Utils.isValueEmpty(dMax)) || ( out.voltage < ( spec.spec.value.input.min * dMax))) ;

    // console.log(" Acceptor_DcDc_Buck acceptSingle_Buck_Vout - buck", ret, (Utils.isValueEmpty(out.voltage)));
    return ret;

  }

  // Added to manage Vout array accepted values
  protected acceptSingle_Buck_Vout_Arr: AcceptorOutputFn = (ic: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    return (ic.vouts && (!Utils.isValueEmpty(out.voltage))) ? ic.vouts.includes(out.voltage) : true;
  }

  protected singleOutputV(): AcceptorOutputFn {return andAcceptorSingle([acceptSingle_common_Vout, this.acceptSingle_Buck_Vout, this.acceptSingle_Buck_Vout_Arr]); }
  protected singleOutputI(): AcceptorOutputFn {return acceptSingle_common_Iout; }
}


